<template>
  <div class="box box-primary">
    <div class="box-header with-border">
      <h3 class="box-title">
        {{ $t('label.editBackground') }}
      </h3>
    </div>
    <div class="box-body">
      <background-form />
    </div>
  </div>
</template>

<script>
import BackgroundForm from './Form'

export default {
  name: 'Edit',
  components: { BackgroundForm },
  metaInfo () {
    return {
      title: this.$t('string.editBackground'),
      titleTemplate: '%s | ' + process.env.VUE_APP_NAME
    }
  }
}
</script>

<style scoped>

</style>
